// Sets formstate on submit of each individual step

const FormStateActions = {
  SET_FORM_STATE: 'FormState.SET_FORM_STATE',
  RESET_FORM_STATE: 'FormState.RESET_FORM_STATE',
};

export default FormStateActions;
